import styles from './EspacioVacio.module.css';

const EspacioVacio = ({ height }) => (
  <div
    className={styles['espacio-vacio']}
    style={height ? { '--espacio-vacio-height': height } : undefined}
    aria-hidden="true"
  />
);

export default EspacioVacio;
